import {FormControlLabel, Switch} from '@mui/material'
import React, {useMemo} from 'react'
import {Controller, useFormContext} from 'react-hook-form'
import {useTranslation} from 'react-i18next'

const FormSwitch = ({name, label, i18nCategory, defaultValue, options}) => {
    const {control} = useFormContext()
    const {t} = useTranslation()
    const optionsDefaultValue = useMemo(() => {
        if (options) {
            return options[1] === defaultValue
        }
        return defaultValue
    }, [defaultValue, options])

    return (
        <Controller
            name={name}
            control={control}
            defaultValue={Boolean(optionsDefaultValue)}
            render={({field}) => (
                <FormControlLabel
                    control={
                        <Switch
                            {...field}
                            defaultChecked={Boolean(optionsDefaultValue)}
                            onChange={(_e, newValue) => {
                                if (options) {
                                    if (newValue) {
                                        return field.onChange(options[1])
                                    } else {
                                        return field.onChange(options[0])
                                    }
                                }
                                return field.onChange(newValue)
                            }}
                        />
                    }
                    label={t(`${i18nCategory}.${label}`)}
                />
            )}
        />
    )
}

export default FormSwitch
